<table>
    <thead>
        <tr>
            <th class="subtable id">{{'mantenimientoDesignaciones.almacenes.id' | translate}}</th>
            <th class="subtable string">{{'global.almacen' | translate}}</th>
            <th class="subtable action">
                <i class="fas fa-plus" *ngIf="showCreate && (this.role === 'Administrador' || this.claims.includes('DSG_ALM_Ins'))"
                    (click)="new=true;almacenEditable=''" title="{{'mantenimientoDesignaciones.almacenes.tituloNew' | translate}}"></i>
            </th>
        </tr>
    </thead>
    <tbody>
        <app-dsg-new-edit-almacenes class="component-in-row" *ngIf="new" [editable]="true" [almacenesList]="almacenesList" [designacionesAlmacen]="designacionesAlmacen" [designacionId]="designacionId" (close)="new=$event"
        (refresh)="toRefresh($event)"
        (pushMessage)="pushMessage.emit($event)"></app-dsg-new-edit-almacenes>
        <app-dsg-new-edit-almacenes class="component-in-row" *ngFor="let designacionAlmacen of designacionesAlmacen" [almacenesList]="almacenesList" [designacionId]="designacionId" [designacionAlmacen]="designacionAlmacen" [designacionesAlmacen]="designacionesAlmacen" [editable]="false" (close)="new=$event"
        (refresh)="toRefresh($event)"
        (pushMessage)="pushMessage.emit($event)"></app-dsg-new-edit-almacenes>
    </tbody>
    <tfoot *ngIf="(!designacionesAlmacen || (designacionesAlmacen && designacionesAlmacen.length < 1)) && !new">
        <tr>
            <td colspan="2">
                {{ 'mantenimientoDesignaciones.almacenes.msgDesignacionAutorizada' | translate}}
            </td>
        </tr>
    </tfoot>
</table>
